<template lang="pug">
  DefaultLayout
    CommonSection(title="Главная")
      .grid
        PersonalTile.personal
        PersonalStatTile.personal-stats(
          title="Проекты"
          unit="проектов"
          color="#19DAC6"
          :value="$store.getters['auth/userProjectCount']"
          :max="$store.getters['auth/userMaxProjects']"
        )
        PersonalStatTile.personal-stats(
          title="Хранилище"
          unit="ГБ"
          color="#FFB27B"
          :value="$store.getters['auth/userStorageCount']"
          :max="$store.getters['auth/userMaxStorage']"
        )
        .block.wide
          .header
            h2.title Последние уведомления
            Btn(sm narrow round :to="{ name: 'notifications' }" style="flex-shrink: 0") Все уведомления
          NotificationList.content(tile)
        .block.news
          .header
            h2.title Новости
            //CarouselArrows(@next="$refs.news.next()" @prev="$refs.news.prev()")
          NewsCarousel.content(ref="news" style="height: 395")
        .block.wide
          .header
            h2.title Контакты
            Btn(sm narrow round :to="{ name: 'contacts' }") Все контакты
          ContactList.content(tile)
        .block
          .header
            h2.title Поддержка
          SupportTile.content
        .block.projects
          .header.short
            h2.title Проекты
            Btn(sm narrow round :to="{ name: 'project-list' }") Все проекты
            CarouselArrows(@next="$refs.projects.next()" @prev="$refs.projects.prev()")
          ProjectCarousel.content(ref="projects")
        .block.tariffs
          .header.short
            h2.title Тарифы
            CarouselArrows(@next="$refs.tariffs.next()" @prev="$refs.tariffs.prev()")
          TariffCarousel.content(ref="tariffs")
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import CommonButtonAdd from '@/components/CommonButtonAdd.vue';
import PageSlug from '@/components/PageSlug.vue';
import ProjectCarousel from '@/components/ProjectCarousel.vue';
import CarouselArrows from '@/components/ui/CarouselArrows.vue';
import TariffCarousel from '@/components/tariff/TariffCarousel.vue';
import ContactList from '@/components/ContactList.vue';
import NotificationList from '@/components/notification/NotificationList.vue';
import SupportTile from '@/components/SupportTile.vue';
import NewsCarousel from '@/components/NewsCarousel.vue';
import PersonalStatTile from '@/components/personal/PersonalStatTile.vue';
import PersonalTile from '@/components/personal/PersonalTile.vue';

export default {
  name: 'Home',
  components: {
    PersonalTile,
    PersonalStatTile,
    SupportTile,
    NewsCarousel,
    NotificationList,
    ContactList,
    TariffCarousel,
    CarouselArrows,
    DefaultLayout,
    CommonSection,
    CommonButtonAdd,
    PageSlug,
    ProjectCarousel,
  },
};
</script>

<style scoped lang="scss">
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 37px 42px;
    align-items: stretch;
  }

  .wide, .notifications, .contacts, .projects {
    grid-column: 2 span;
  }

  .header {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    margin-bottom: 30px;
    height: 26px;

    &.short {
      margin-bottom: 10px;
    }
  }

  .title {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #232226;
    margin-right: auto;
  }

  .block {
    display: flex;
    flex-direction: column;
  }

  .content {
    flex-grow: 1;
  }

  @media (max-width: 1500px) {
    .grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }

    .personal {
      grid-column: 2 span;
    }

    .personal-stats {
      flex-direction: column;
    }

    .projects {
      grid-column: 1 span;
    }

    .news {
      grid-row: 5;
    }

  }

  @media (max-width: 992px) {
    .tariffs, .projects {
      grid-column: 2 span;
    }
  }

  @media (max-width: 768px) {

    .grid {
      grid-template-columns: 1fr;
    }

    .wide, .personal, .tariffs, .projects {
      grid-column: 1 span;
    }

    .news {
      grid-row: 7;
    }
  }

</style>
